import React from "react";

const About: React.FC = () => (
  <div className="w-5/6 mx-auto max-w-[700px]">
    <div className="font-bold text-[2.5rem] underline text-center mt-10">
      ... කිතුල්ගොඩ අරණ්‍ය සේනාසනය පිළිබඳව ...
    </div>
    <div className="text-lg about">
      <p>
        මතුගම අගලවත්ත නගරයේ සිට සැතපුම් දහයක් පමණ ඈතින් පිහිටි කිතුල්ගොඩ
        අරණ්‍යසේනාසනය ස්වභාවික වෘක්‍ෂලතාවන්ගෙන් වැසී ගිය අක්කර 21ක පමණ වූ රමණීය
        වන පෙදෙසකි. කිතුල්ගොඩ අරණ්‍ය සේනාසනය ක ̈තර දිස්ත්‍රික්කයේ අගලවත්ත
        ප්‍රාදේශීය සභාවට අයත් වූවකි කුරුල්ලන්ගේ මිහිරි ගී නාදයත් රුක්ගොමුවලින්
        ගහන නිල්වන් පියස වටා පවුරක් බැඳි විලස පෙණ පිඩු විසුරුවමින් ගලන මනරම් දොළ
        පහරත් නිරතුරුවම හමන සිසිල් සුළඟත් මෙහි පිවිසෙන්නෙකුගේ ගත සිත සැහැල් ̈වට
        පත් කරයි. වෛi අනුර වීරසිංහ මහතා තමන්ට අයත්ව තිබු මෙම භූමි භාගය තම ධනය
        ශ්‍රමය යොදවා සම්බුදු සසුනට අරණ්‍යය සේනාසනයක් දායද කිරීමට වසර කිහිපයක සිට
        දරණ ලද උත්සාහයේ ප්‍රතිඵලය මල්ඵල ගන්වමින් මෙහි අනුශාසකත්වයට මහරගම සිරි
        වජිරඤාණ ධර්මායතනවාසී පූජ්‍ය වැලිමඩ පසන්නමානස ස්වාමින්ද්‍රයන් වහන්සේ
        පත්වූහ.
      </p>
      <p>
        අප ස්වාමින්ද්‍රයන් වහන්සේ අපවත් වී වදාළ අමරපුර ශ්‍රී ධර්මරක්‍ෂිත
        මහානිකායේ අතිපූජ්‍ය මහානායක මඩිහේ පඤ්ඤාසීහ ස්වාමින් වහනසේගේ
        උපාධ්‍යායත්වයෙන් හා සුජීවත්ව වැඩ සිටින අතිපූජ්‍ය අම්පිටියේ ශ්‍රී රාහුල
        ස්වාමින් වහනසේගේත් ආචාර්යත්වයෙන් බිහිවූ ශිෂ්‍ය රත්නයකි. ඒ අනුව 2010 වසරේ
        මුල් භාගයේදී සතර දිගින් වඩින මහ සඟරුවනට සඟසතු කොට පූජා කරන ලද මෙම
        කිතුල්ගොඩ අරණ්‍ය සෙනසුන ර්‍ණචිත්ත සමාධියක් තුළින් සදාචාරාත්මක ලොවකට” යන
        උසස් තේමාව පෙරදැරිව බුදුරජාණන් වහන්සේගේ නිර්මල ශ්‍රී සද්ධර්මය ප්‍රචාරය
        කිරීම සදහා විනයධර ධර්මධර සිල්වත්ල ගුණවත් භික්‍ෂූන් වහන්සේලා පිරිසක්
        බිහිකිරීමත්ල සියළු පහසුකම් සහිතව භාවනායෝගී සැමට භාවනා කිරීමට සුදුසු
        ස්ථානයක් ඇති කිරීමත් මූලික පරමාර්ථ කොට ගෙන පිහිටවන ලදීග අද වන විට මෙම
        අරණ්‍ය සේනාසනයේ බණබවුන් වඩමින් ස්වාමින් වහන්සේලා කිහිප නමක් වැඩ වාසය කරන
        අතර භික්‍ෂූණ් වහන්සේලාගේ පහසුව පිණිස අරණ්‍ය පුරා තැනින් තැන කුටි සෙනසුන්
        ඉදිකර ඇතග දෙස් විදෙස් ආගන්තුක ස්වාමින් වහන්සේලා සදහාද මෙහි පවතින ඉඩ
        පහසුකම් මත බවුන් වැඩීමට හැකියාව ඇත්තේයග.
      </p>
      <p>
        අරණ්‍යයේ වාසය කරන භික්‍ෂූණ් වහන්සේගේ දෛනික චර්යාව සිදු කෙරෙන්නේ
        කතිකාවතක් අනුවයග වතාවත් කිරීම වන්දනා කිරීම පිණ්ඩපාත කිරීම ත්‍රිපිටක පත
        පොත් කිරීම භාවනා කිරීම මීට අයත් ප්‍රධාන කාර්්‍යයන් වේග ආරණ්‍ය සේනාසනයේ
        පරිපාලන කටයුතු අනුශාසක ස්වාමින් වහන්සේගේ පූර්ණ සොයාබැලීම මත කිතුල්ගොඩ
        අරණ්‍ය සේනාසන සංවර්ධන සමිතිය සහ කිතුල්ගොඩ අරණ්‍ය සේනාසන උපස්ථායක කමිටුව
        මඟින් මේ වනවිට සිදු කරනු ලබයිග සෑම පුර පසළොස්වක පොහෝ දිනයකම ක්‍රමානුකූලව
        පවත්වාගෙන යනු ලබන සීල සමාදානයල සෑම සෙනසුරාදා දිනකම උදෑසන සිට සවස තෙක්
        පවත්වනු ලබන විශේෂ භාවනා වැඩසටහන් මෙන්ම නේවාසික භාවනා පුහුණව තුලින්
        දැහැමි ගිහි සමාජයක් බිහිකිරීමේ අර්ථපූර්ණ ක්‍රියාශීලි දායකත්වයක් ලබාදීම
        විශේෂයෙන් පැසසිය යුත්තකිග තවද සෙනසුරාදා දින පැවැත්වෙන භාවනා වැඩසටහන්
        සදහා කාන්තාල පිරිමි දෙපාර්ශවයටම සහභාගී විය හැකි අතර නේවාසික භාවනා පුහුණව
        සදහා දැනට පවතින පහසුකම් මත පිරිමි පාර්ශවය සදහා පමණ් සහභාගී වීමට අවස්ථාව
        උදා වී ඇතග තවද ඒ අය උදෙසා ත්‍රිපිටක ධර්මය හැදෑරීමේ පහසුකම් ද සලසා ඇතග
      </p>
      <span className="font-bold text-2xl text-center lg:text-right underline w-1/2 min-w-[300px] mx-auto">
        පුදබිමට ළඟාවිය හැකි මඟ...
      </span>
      <p>
        මතුගම නගරය පසුකරමින් අගලවත්ත නගරයට පැමිණ පැලවත්ත ප්‍රධාන මාර්ගයේ ගමන්කර
        බෙල්ලන හන්දියෙන් දකුණට හැරී සැතපුම් තුනක් පමණ දුරක් පසුකල විට කිතුල්ගොඩ
        අරණ්‍යය සේනාසනයේ නාම පුවරුව වම්පසින් දිස්වේග එතැනින් වමට හැරී මීටර්
        දෙසියයක් පමණ දුර ගිය විට මේ පින්බිමේ ප්‍රධාන පිවිසුමට ඔබට ළඟාවිය හැකිය
      </p>
    </div>
  </div>
);

export default About;
